import { Teaser as t } from '@xprog/prensa/types'

export const TeaserImageLeftSm: t.TeaserProps = {
  css: {
    padding: '$0',
    mb: '$6',
    minHeight: '88px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: 'calc(120px + $3)',
      width: 'auto',
      'img': {
        pr: '$3'
      },
      '@lg': {
        maxWidth: '150px'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px',
      mb: '$2'
    },
    '.TeaserSubtitleText': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle'],
    },
    '.TeaserTitle': {
      mb: '$2'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      color: 'black',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      width: '100%'
    },
    '.TeaserWrap': {
      // maxWidth: 'calc(100% - 88px - $3)',
      width: '100%',
    }
  },
  className: 'TeaserImageLeftSm',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-md'
}